module.exports = __webpack_public_path__ + "img/current-account.e8ac001.webp";